import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, Col, Row, Container } from 'react-bootstrap';

import SignUp from '../../components/auth/SignUp';
import { Link } from 'react-router-dom';

import appLogo from '../../assets/img/new/disputelylogonew2-139.svg';
import appLogoWhite from '../../assets/img/disputely-logo-white.svg';
import CreateBG from './create-account-bg.png';
import Advantages from './Advantages.svg';
import Heading from './Heading.svg';

const SignUpPage = () => (
  <React.Fragment>
    <Helmet title='Sign Up' />
    <style>
      {`
  .centered-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

  `}
    </style>
    <Row className='h-100'>
      <Col lg='5' className='p-5 create-bg d-none d-xl-block' style={{ backgroundImage: `url(${CreateBG})`, backgroundColor: 'var(--bs-primary)', backgroundSize: 'cover', position: 'relative' }}>
        <div className='centered-content'>
          <img src={Heading} alt='Heading' className='mb-5' />
          <img src={Advantages} alt='Advantages' />
        </div>
        <Container>
          <img className='disputely-logo-new-2-1-icon40 mb-5' alt='' src={appLogoWhite} />
        </Container>
      </Col>

      <Col xl={4} lg={6} md={6} xs={9} className='m-auto'>
        <img className='w-50 mb-4 mx-auto d-block d-xl-none' alt='' src={appLogo} />
        <div>
          <h3 className='text-dark-blue mb-2 mb-xl-5'>Create Account</h3>
          <SignUp />
          <Col lg='12'>
            <p className='text-center mt-xl-5 mt-3'>
              Already have an account?{' '}
              <Link to='/' className='text-decoration-none d-block d-md-inline'>
                Sign in.
              </Link>
            </p>
          </Col>
        </div>
      </Col>
    </Row>
  </React.Fragment>
);

export default SignUpPage;
